// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { CreditMemoLedgerEntry } from './credit-memo-ledger-entry';
import { CreditMemoLedgerEntryKindEnum } from './enums';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class CreditMemoLedgerEntryKind extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Enum key */
  id!: CreditMemoLedgerEntryKindEnum;
  /** String(50) */
  name!: string;
  /** Inv FK kindId */
  creditMemoLedgerEntries!: CreditMemoLedgerEntry[];
}

